import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'default',
    standalone: false
})
export class DefaultPipe implements PipeTransform {
    public transform(value: unknown, defaultValue: unknown): unknown {
        return value ?? defaultValue;
    }
}
